import NrIcon from '../NrIcon';
export default {
  name: 'NrBanner',
  components: {
    NrIcon: NrIcon
  },
  props: {
    type: String
  },
  methods: {
    getTypeIdentifier: function getTypeIdentifier(type) {
      return type.replace(/\s/, '').toLowerCase();
    },
    getIcon: function getIcon(icon) {
      switch (icon) {
        case 'overdue':
          return 'exclamation-triangle';
        case 'open':
          return 'folder-open';
        case 'closed':
          return 'check-square';
        case 'duesoon':
          return 'flag';
        case 'paused':
        default:
          return 'pause';
      }
    }
  }
};